import { EmptyGuid, isValidGuid } from "../utils";

export class Animal {
  public guid: string | null;
  public name: string;
  public breedGuid: string | null;
  public mixedBreed: boolean;
  public gender: string;
  public sterilized: boolean;
  public birthDate: Date | null;
  public vaccinesGuids: string[];

  constructor(
    guid: string | null,
    name: string,
    breedGuid: string | null,
    mixedBreed: boolean,
    gender: string,
    sterilized: boolean,
    birthDate: Date | null,
    vaccinesGuids: string[])
  {
    this.guid = isValidGuid(guid) ? guid : EmptyGuid;
    this.name = name;
    this.breedGuid = breedGuid;
    this.mixedBreed = mixedBreed;
    this.gender = gender[0];
    this.sterilized = sterilized;
    this.birthDate = birthDate;
    this.vaccinesGuids = vaccinesGuids;
  }
}